import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { ReportingScreen } from "../reporting/ReportingScreen";
import { useScope } from "../auth/ScopeGate";

// File name matters: `_authed.reporting.tsx` nests this under the _authed layout, so it gets
// the per-session query client and a resolved scope. A bare `reporting.tsx` would generate a
// ROOT-level route with no ScopeGate above it, and useScope would throw.
export const Route = createFileRoute("/_authed/reporting")({ component: ReportingRoute });

function ReportingRoute() {
  const scope = useScope();
  const navigate = useNavigate();

  // UX, not security: this screen is owner-only, matching Team and Settings. FR-R4 may
  // later let a site manager see their own site; until then bounce them to the board.
  useEffect(() => {
    if (scope.role !== "Owner") void navigate({ to: "/" });
  }, [scope.role, navigate]);

  if (scope.role !== "Owner") return null;
  return <ReportingScreen businessId={scope.businessId} />;
}
